import React from 'react';
import PropTypes from 'prop-types';
import ColorsSection from 'admin/views/site-designer/modules/sections/components/Color';
import RangeSection from 'admin/views/site-designer/modules/sections/components/Range';

const Overlay = ({
   value,
   rangLable,
   colors,
   onChange,
   name,
}) => {
   const onChangeOverlay = (key, keyValue) => {
      onChange(name, { ...value, [key]: keyValue });
   }
   return (
      <div className='flex flex-col gap-2'>
         <ColorsSection
            options={ colors }
            value={ value.color }
            onChange={ onChangeOverlay }
         />
         <div className='flex flex-col gap-8'>
            <div className='flex justify-between'>
               {
                  rangLable && <span className='text-base font-medium leading-[20px] text-major'>{rangLable}</span>
               }
               <span className='text-base font-medium leading-[20px] text-major'>{value.opacity}%</span>
            </div>
            <RangeSection
               value={ value.opacity }
               lable={ rangLable }
               name={ `${ name }_overlay_opacity` }
               onChange={ (name, value) => onChangeOverlay('opacity', value) }
            />

         </div>
      </div>
   );
};


Overlay.propTypes = {
   colors: PropTypes.array,
   rangLable: PropTypes.string,
   value: PropTypes.object,
   onChange: PropTypes.object,
   name: PropTypes.string,
};
Overlay.defaultProps = {
}

export default Overlay;
